'use client'

import {
    Box,
    Flex,
    Text,
    Stack,
    Icon,
} from '@chakra-ui/react'
import {
    ChevronRightIcon,
} from '@chakra-ui/icons'
import styles from '../../NavBar.module.scss'
import { NavItem_t } from '../../NavBarTypes/NavItem'

const primaryFontSize = "1rem"
const secondaryColorOne = "green.400"

function DesktopSubNav({ label, href, subLabel, target }: NavItem_t) {
    return (
        <Box
            className={styles['desktop__sub-nav__container']}
            as="a"
            href={href}
            role={'group'}
            display={'block'}
            target={target ?? ''}
            p={2}
            rounded={'md'}
        >
            <Stack className={styles['desktop__sub-nav__stack']}
                direction={'row'} align={'center'}>
                <Box>
                    <Text
                        transition={'all .3s ease'}
                        _groupHover={{ color: secondaryColorOne }}
                        fontWeight={500}>
                        {label}
                    </Text>
                    <Text fontSize={primaryFontSize}>{subLabel}</Text>
                </Box>
                <Flex
                    transition={'all .3s ease'}
                    transform={'translateX(-10px)'}
                    opacity={0}
                    _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
                    justify={'flex-end'}
                    align={'center'}
                    flex={1}>
                    <Icon color={'green.400'} w={5} h={5} as={ChevronRightIcon} />
                </Flex>
            </Stack>
        </Box>
    )
}

export default DesktopSubNav;
